<template>
    <div class="table-card-wrapper">
        <b-card body-class="p-0 border-0" header-class="border-0 h5 text-black"
        :class="{'border-top-0 tabs-card border-left border-right intab': inTab }">
            <template slot="header">
                <div class="header">
                    <span class="header-title">
                        <slot name="title">
                            {{ title }}
                        </slot>
                    </span>
                    <slot name="header">
                      <!-- filtering etc content before search bar -->
                    </slot>
                    <span v-if="searchable" class="float-right">
                        <b-input-group>
                            <div slot="prepend" class="input-group-text">
                                <i class="icon icon-Search"></i>
                            </div>
                            <b-input class="m-0" placeholder="Search" v-model="filter"></b-input>
                        </b-input-group>
                    </span>
                </div>
            </template>
            <b-table
                :sort-by="sortBy || (fields && (fields[0].key || fields[0]))"
                :sort-desc="sortDir == 'desc'"
                :sort-asc="sortDir == 'asc'"
                class="m-0 table-card-table accent-hover-wrapper"
                head-variant="light"
                thead-class="small"
                thead-tr-class="small text-uppercase"
                tbody-class="text-black"
                tbody-tr-class="hidden-button-holder"
                :filter-ignored-fields="['edit', 'show_details', 'settings', 'actions', 'expired', 'delete', 'DELETE', 'status']"
                :filter-function="customFilter"
                @row-clicked="rowClicked"
                @filtered="onFiltered"
                :items="items"
                :fields="tableFields"
                :per-page="perPage"
                :filter="filterDebounced"
                :current-page="currentPage"
                show-empty>
                <!-- lets us use the column templates in parent component -->
                <template v-for="slot in slots" :slot="slot.name" slot-scope="data">
                    <slot :name="slot.name" v-bind="data" />
                </template>
                <template v-slot:cell(show_details)="data">
                    <!-- remove text-primary once accent-color(s) have been defined -->
                    <span class="icon h4 p-0"
                        :class="{ 'icon-Table_Arrow_Close': data.detailsShowing,
                            'icon-Table_Arrow_Open': !data.detailsShowing }">
                    </span>
                </template>
            </b-table>
        </b-card>
        <br>

        <span v-if="pagination && !empty" class="per-page-select">
            <b-form-select
                v-model="perPage"
                :options="perPageOptions"
                class="rounded">
            </b-form-select>
        </span>
        <b-pagination
            v-if="pagination && !empty"
            align="center"
            :total-rows="totalRows"
            v-model="currentPage"
            :per-page="perPage">
        </b-pagination>

    </div>
</template>

<script>
import App from '@/main'

export default {
    data(){
        return {
            perPage: 10,
            filter: '',
            filterDebounced: '',
            filterTimeout: null,
            perPageOptions: [
                { value: 5, text: '5 per page' },
                { value: 10, text: '10 per page' },
                { value: 15, text: '15 per page' }
            ],
            currentPage: 1,
            numFilteredRows: null
        }
    },
    props: {
        inTab: { required: false, type: Boolean, default: false },
        title: { required: false, type: String },
        items: { required: true, type: Array, default: [] },
        fields: { required: false, type: Array },
        pagination: { required: false, type: Boolean, default: true },
        searchable: { required: false, type: Boolean, default: true },
        sortBy: { required: false, type: String },
        sortDir: { required: false, type: String, default: 'asc' }
    },
    computed: {
        //number of rows currently displayed in table
        totalRows () {
            return this.numFilteredRows || this.items.length
        },
        empty () {
            return this.items.length === 0
        },
        slots () {
            let slots = []
            for (let name in this.$scopedSlots) {
                slots.push({ name: name })
            }
            return slots
        },
        hasDetails () {
            for (let slot of this.slots) {
                if (slot.name === 'row-details') {
                    return true
                }
            }
            return false
        },
        tableFields () {
            let fields = this.fields
            if (!fields) {
                if (!this.items || !this.items.length) {
                    return null
                }

                fields = []
                for (let key in this.items[0]) {
                    fields.push(key)
                }
            }

            if (this.hasDetails) {
                fields.unshift({ key: 'show_details', label: '' })
            }
            if (typeof fields[0] === 'object') {
                if('tdClass' in fields[0]) {
                    fields[0].tdClass += ' accent-hover-element'
                } else {
                    fields[0].tdClass = 'accent-hover-element'
                }
            }

            return fields
        }
    },
    watch: {
        filter(val) {
            clearTimeout(this.filterTimeout)
            this.filterTimeout = setTimeout(() => {
                this.filterDebounced = val
            }, 300)
        }
    },
    methods: {
        customFilter(row, filter) {
            if (!filter || filter.trim() === '') return true
            
            const searchTerm = filter.toLowerCase().trim()
            const ignoredFields = ['edit', 'show_details', 'settings', 'actions', 'expired', 'delete', 'DELETE', 'status', '_showDetails', '_rowVariant', '_cellVariants']
            
            // Simple text search across all non-ignored fields
            for (const key in row) {
                if (ignoredFields.includes(key)) continue
                if (key.startsWith('_')) continue // Skip any internal Vue/b-table properties
                
                const value = row[key]
                if (value === undefined || value === null) continue
                
                // Handle objects (like nested company data)
                if (typeof value === 'object') {
                    // Don't search through objects/arrays for now
                    continue
                }
                
                const stringValue = String(value).toLowerCase()
                if (stringValue.includes(searchTerm)) {
                    return true
                }
            }
            
            return false
        },
        rowClicked (data) {
            if (!this.hasDetails) {
                return /* nothing to do.. */
            }

            this.$set(data, '_showDetails', !data._showDetails)

            if (data._showDetails) {
                /* only emit event on show not close */
                this.$emit('show-details', data)
            }
        },
        onFiltered (filteredItems) {
            this.numFilteredRows = filteredItems.length
            this.currentPage = 1
        }
    },
}
</script>

<style>
.table-card-wrapper .b-table-details > td {
  padding: 0;
}
.hidden-button-holder .hidden-button-group {

}
.hidden-button-holder:hover .hidden-button-group {
  visibility: visible;
}
.accent-hover-wrapper tr:hover td.accent-hover-element::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    background-color: var(--primary);
}
.accent-hover-wrapper tr:hover td.accent-hover-element {
    position: relative;
}
.table-card-wrapper .card-header {
    /*background-color: var(--lighter);*/
}
.table-card-wrapper .b-table-details:hover {
    background-color: inherit !important;
}
.majorField {
  font-size: 15px;
}
.minorField {
  font-size: 13px;
}
.minorField a.btn-link {
  font-size: 13px !important;
}
</style>
<style scoped>
.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.table-card-wrapper {
    position: relative;
}
.per-page-select {
    position: absolute;
    right: 0;
    float:right;
}
  .intab {
    border-top-right-radius: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/TableCard.vue